const INITIAL_STATE = {
  total: 0,
  processed: 0,
};

function progressSegmentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@progress/SET_TOTAL': {
      return {
        ...state,
        total: action.payload,
      };
    }

    case '@progress/INCREMENT': {
      return {
        ...state,
        processed: state.processed + 1,
      };
    }

    case '@progress/RESET': {
      return {
        ...INITIAL_STATE,
      };
    }

    default: {
      return state;
    }
  }
}

export { progressSegmentReducer };
